// extracted by mini-css-extract-plugin
export var component = "TableModule-module--component--peb8s";
export var table = "TableModule-module--table--6WOug";
export var title = "TableModule-module--title--Qq9MC";
export var head = "TableModule-module--head--i-TT3";
export var th = "TableModule-module--th--k7eyj";
export var td = "TableModule-module--td--YoX0I";